import { Row, Col, Button } from "react-bootstrap";
import DeliveryMethods from "../../components/alertPrefernces/DeliveryMethods";
import AlertTypes from "../../components/alertPrefernces/AlertTypes";
import NotificationTiming from "../../components/alertPrefernces/NotificationTiming";
import AlertLocations from "../../components/alertPrefernces/ AlertLocations";
import AdditionalSettings from "../../components/alertPrefernces/AdditionalSettings";
import RightPanel from "../../components/alertPrefernces/RightPanel";
import { FaBell } from "react-icons/fa";
import { useEffect, useState } from "react";
import Notifications from "../../components/alertPrefernces/Notifications";
import { errorAlert } from "../../components/common/Alert";
import { getNotificationsApi } from "../../services/Networkcall";


export default function AlertPreferences() {
    const [notifications, setNotifications] = useState([]);
    const [pagination, setPagination] = useState({page:1, limit:50, totalPages:1, totalRecords:1})
    const [loading, setLoading] = useState(false)

    const fetchNotifications = async () => {
        setLoading(true)
        try {
            const res = await getNotificationsApi({ page: pagination?.page, limit: pagination?.limit });
            if (res?.success) {
                setNotifications(res?.data || [])
                setPagination((pre) => ({ ...pre, totalPages: res?.totalNumberOfPages, totalRecords: res?.totalRecords }));
            } else {
                errorAlert({message:res?.message || 'Failed to fetch notifications.'})
            }
        } catch (err) {
         errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong" })
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchNotifications();
    }, [])
    
     


    return (
        <div className="ap-page vh-100 overflow-scroll">

            {/* HEADER */}
            <div className="ap-header">
                <div>
                    <h4>Alerts & Notifications</h4>
                    {/* <p>Choose how and when you want to be notified.</p> */}
                </div>

                <div className="ap-actions">
                    <Notifications notifications={notifications} loading={loading} />
                </div>
            </div>

            {/* CONTENT */}
            <Row className="ap-layout">

                {/* LEFT */}
                <Col xl={8} lg={12}>
                    <DeliveryMethods />
                    <AlertTypes />
                    <Row>
                        {/* <Col md={6}>
                            <NotificationTiming />
                        </Col> */}
                        {/* <Col md={6}>
                            <AlertLocations />
                        </Col> */}
                        {/* <Col md={6}>
                           <AdditionalSettings />
                        </Col> */}
                    </Row>
                    

                    {/* <div className="ap-footer">
                        <Button variant="light">Cancel</Button>
                        <Button>Save Preferences</Button>
                    </div> */}
                </Col>

                {/* RIGHT */}
                <Col xl={4} lg={12}>
                    <RightPanel notifications={notifications} />
                </Col>

            </Row>

        </div>
    );
}